module.exports = require("@swa-ui/authentication/src/components/MissingInformationSaveStatus/MissingInformationSaveStatus.module.scss");